import { render, staticRenderFns } from "./settings-templates.vue?vue&type=template&id=67a56dfd&scoped=true&"
import script from "./settings-templates.ts?vue&type=script&lang=ts&"
export * from "./settings-templates.ts?vue&type=script&lang=ts&"
import style0 from "./settings-templates.vue?vue&type=style&index=0&id=67a56dfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a56dfd",
  null
  
)

export default component.exports